import { render, staticRenderFns } from "./kodetransaksi.vue?vue&type=template&id=b1a8f9e0&scoped=true&"
import script from "./kodetransaksi.vue?vue&type=script&lang=js&"
export * from "./kodetransaksi.vue?vue&type=script&lang=js&"
import style0 from "./kodetransaksi.vue?vue&type=style&index=0&id=b1a8f9e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8f9e0",
  null
  
)

export default component.exports